import SpineApi, { SPINE_API_URL } from '@/api/base/SpineApi'

export default {
  getPaymentSources() {
    return SpineApi.get(`${SPINE_API_URL}/payment_wallet`)
  }
}
